import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

import {useDispatch, useSelector} from 'react-redux';
import {initiateWizard, onExitWizard} from 'stores/business/setupWizardBusiness/setupWizardBusiness';
import {checkLoadCellError} from 'stores/business/loadCellErrorBusiness';

import '../SetupWizard.scss';
import {getTrayCalibrationTrayType} from 'stores/selectors/trayCalibrationSelectors';
import {TrayType} from 'constants/dataEnum';
import SetupWizardImage from '../SetupWizardImage';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';
import {SetupWizardStep} from '../../../constants/SetupWizardEnum';

const svgLocation = (imageName) => `./svg/preparation-wizard/${imageName}.svg`;

export function FirstPageSetupWizard({intl}) {
  const dispatch = useDispatch();
  const trayType = useSelector(getTrayCalibrationTrayType);
  const isHVTrayInstalled = trayType === TrayType.HIGH_VOLUME_CADDY;

  const onInitiateWizard = async () => {
    const isLoadCellError = await dispatch(checkLoadCellError(null, onInitiateWizard));
    if (isLoadCellError) return;
    dispatch(initiateWizard());
  };

  return (
    <div className="landing-page">
      <img className="icon" alt={svgLocation('logo')} src={svgLocation('logo')} />
      <p className="landing-page__title">{intl.formatMessage({id: 'setupWizard.step.welcomeScreen.title'})}</p>
      <div className="landing-page__image">
        <SetupWizardImage stepName={SetupWizardStep.WELCOME_SCREEN} trayType={trayType} />
      </div>
      <p className="landing-page__image-caption">
        <FormattedHTMLMessage id={`setupWizard.step.welcomeScreen.${isHVTrayInstalled ? 'highVolume.' : ''}text`} />
      </p>
      <Button className="button-primary button-start" onClick={onInitiateWizard}>
        {intl.formatMessage({id: 'setupWizard.step.welcomeScreen.firstButton'})}
      </Button>
    </div>
  );
}

FirstPageSetupWizard.propTypes = {
  intl: PropTypes.any.isRequired,
};

export function LastPageSetupWizard({intl}) {
  const dispatch = useDispatch();
  const onEndWizard = () => dispatch(onExitWizard());

  return (
    <div className="end-page">
      <img className="icon" alt={svgLocation('logo')} src={svgLocation('logo')} />
      <div className="content-image">
        <SetupWizardImage stepName={SetupWizardStep.FINISH_SCREEN} />
      </div>
      <div className="flex-centered">
        <span className="icon-check-end icon-checkbox-default" />
        <div>
          <p className="title">{intl.formatMessage({id: 'setupWizard.step.finishScreen.title'})}</p>
          <p className="subtext">
            <FormattedHTMLMessage id="setupWizard.step.finishScreen.text" />
          </p>
        </div>
      </div>
      <br />
      <Button className="button-primary button-end" onClick={onEndWizard}>
        {intl.formatMessage({id: 'setupWizard.step.finishScreen.firstButton'})}
      </Button>
    </div>
  );
}

LastPageSetupWizard.propTypes = {
  intl: PropTypes.any.isRequired,
};
